import { IContactsConfig } from "@/config/contacts.config";

// France-specific contacts configuration override
// NOTE: address is intentionally not set — the address is temporarily hidden
// on the site until the office lease is officially signed.
export const franceContactsConfig: Partial<IContactsConfig> = {
  phone: "+33634258257",
  email: "info@avezor.fr",
  whatsapp: "https://wa.me/33634258257",
  // Telegram and Viber are not connected for the French office yet
  telegram: undefined,
  viber: undefined,
  location: {
    city: "Paris",
    country: "France",
  },
};

export default franceContactsConfig;
